import { useState, useRef, useEffect } from "preact/hooks";
import type { ComponentChildren } from "preact";

// Full emoji picker: unicode chars (stored as-is). Grouped for easier browsing.
const EMOJI_LIST = [
  "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎", "💔", "❣️", "💕", "💞", "💓", "💗", "💖", "💘", "💝",
  "😀", "😃", "😄", "😁", "😆", "😅", "🤣", "😂", "🙂", "🙃", "😉", "😊", "😇", "🥰", "😍", "🤩", "😘", "😗", "☺️", "😚", "😙", "🥲", "😋", "😛", "😜", "🤪", "😝", "🤑", "🤗", "🤭", "🤫", "🤔", "🤐", "🤨",
  "😐", "😑", "😶", "😏", "😒", "🙄", "😬", "🤥", "😌", "😔", "😪", "🤤", "😴", "😷", "🤒", "🤕", "🤢", "🤮", "🤧", "🥵", "🥶", "🥴", "😵", "🤯", "🤠", "🥳", "🥸",
  "😎", "🤓", "🧐", "😕", "😟", "🙁", "☹️", "😮", "😯", "😲", "😳", "🥺", "😦", "😧", "😨", "😰", "😥", "😢", "😭", "😱", "😖", "😣", "😞", "😓", "😩", "😫", "🥱", "😤", "😡", "😠", "🤬", "😈", "👿",
  "👍", "👎", "👊", "✊", "🤛", "🤜", "🤞", "✌️", "🤟", "🤘", "👌", "🤌", "🤏", "👈", "👉", "👆", "👇", "☝️", "✋", "🤚", "🖐️", "🖖", "👋", "🤙", "💪", "🦾", "🖕", "🙏",
  "👏", "🙌", "👐", "🤲", "🤝", "🙏",
  "🔥", "⭐", "🌟", "✨", "💫", "💥", "💯", "💢", "💦", "💨", "🕳️", "💣", "💬", "👁️", "👀", "🧠", "🫀", "🫁", "🦷", "🦴", "👃", "👂", "🦻", "👅", "👄",
  "🎉", "🎊", "🎈", "🎁", "🏆", "🥇", "🥈", "🥉", "⚽", "🏀", "🏈", "⚾", "🥎", "🎾", "🏐", "🏉", "🥏", "🎱", "🪀", "🏓", "🏸", "🏒", "🏑", "🥍", "🏏", "🪃", "🥅", "⛳", "🪁", "🏹", "🎣", "🤿", "🥊", "🥋", "🎽", "🛹", "🛼", "🛷", "⛸️", "🥌", "🎿", "⛷️", "🏂", "🪂", "🏋️", "🤸", "⛹️", "🤾", "🏌️", "🏇", "⛹️", "🤾", "🏌️", "🏇",
  "🎵", "🎶", "🎸", "🎹", "🎺", "🎻", "🪕", "🥁", "🪘", "🪗", "🎷", "🎤", "🎧", "📻", "🎙️", "🎚️", "🎛️",
  "☕", "🍵", "🍶", "🍺", "🍻", "🥂", "🍷", "🥃", "🍸", "🍹", "🍾", "🥄", "🍴", "🍽️", "🥣", "🥡", "🥢", "🍽️",
  "🍕", "🍔", "🍟", "🌭", "🥪", "🌮", "🌯", "🥙", "🧆", "🥚", "🍳", "🥘", "🍲", "🥣", "🥗", "🍿", "🧈", "🧂", "🥫", "🍱", "🍘", "🍙", "🍚", "🍛", "🍜", "🍝", "🍠", "🍢", "🍣", "🍤", "🍥", "🥮", "🍡", "🥟", "🥠", "🥮", "🍦", "🍧", "🍨", "🍩", "🍪", "🎂", "🍰", "🧁", "🥧", "🍫", "🍬", "🍭", "🍮", "🍯", "🍼", "🥛", "☕",
  "🚀", "✈️", "🛫", "🛬", "🛩️", "💺", "🛰️", "🚁", "🛸", "🚲", "🛵", "🏍️", "🛺", "🚨", "🚔", "🚍", "🚘", "🚖", "🚡", "🚠", "🚟", "🚃", "🚋", "🚞", "🚝", "🚄", "🚅", "🚈", "🚂", "🚆", "🚇", "🚊", "🚉", "✈️",
  "🌈", "☀️", "🌤️", "⛅", "🌥️", "☁️", "🌦️", "🌧️", "⛈️", "🌩️", "🌨️", "❄️", "☃️", "⛄", "🌬️", "💨", "💧", "💦", "☔", "☂️", "🌊", "🌫️",
  "🌍", "🌎", "🌏", "🌐", "🗺️", "🧭", "🏔️", "⛰️", "🌋", "🗻", "🏕️", "🏖️", "🏜️", "🏝️", "🛤️", "🛣️", "🗾", "🎑", "🏞️",
  "🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼", "🐨", "🐯", "🦁", "🐮", "🐷", "🐸", "🐵", "🙈", "🙉", "🙊", "🐒", "🐔", "🐧", "🐦", "🐤", "🐣", "🐥", "🦆", "🦅", "🦉", "🦇", "🐺", "🐗", "🐴", "🦄", "🐝", "🐛", "🦋", "🐌", "🐞", "🐜", "🦟", "🦗", "🕷️", "🦂", "🐢", "🐍", "🦎", "🦖", "🦕", "🐙", "🦑", "🦐", "🦞", "🦀", "🐡", "🐠", "🐟", "🐬", "🐳", "🐋", "🦈", "🐊",
  "🌱", "🌲", "🌳", "🌴", "🌵", "🌾", "🌿", "☘️", "🍀", "🍁", "🍂", "🍃", "🍄", "🌰", "🦀", "🦞",
  "📌", "📍", "📎", "🖇️", "📏", "📐", "✂️", "🗃️", "🗄️", "🗑️", "🔒", "🔓", "🔏", "🔐", "🔑", "🗝️", "🔨", "🪓", "⛏️", "🛠️", "🗡️", "⚔️", "🔫", "🛡️", "🪤", "🔧", "🔩", "⚙️", "🗜️", "⚖️", "🦯", "🔗", "⛓️", "🪝", "🧰", "🪛", "🧲", "⛏️",
  "✅", "❌", "❓", "❗", "‼️", "⁉️", "💯", "🔅", "🔆", "📛", "🚫", "⛔", "🚷", "🚯", "🚳", "🚱", "🔞", "📵", "🚭", "❗", "💢", "💥", "💤", "💨", "🕳️", "🛑", "⛔", "📛", "🚫",
];

const POPUP_WIDTH = 280;

// Top 10 commonly used favorites
const DEFAULT_FAVORITES = ["❤️", "😂", "👍", "👎", "🎉", "🔥", "⭐", "🙏", "👏", "💯"];

export interface EmojiPickerProps {
  /** Called when user selects an emoji. Return true to close the picker. */
  onSelect: (emoji: string) => boolean | void;
  /** Trigger button content (default: ⊕) */
  trigger?: ComponentChildren;
  /** Trigger button className */
  triggerClassName?: string;
  /** Emojis currently used in the calendar (slots + chat) - shown in favorites */
  usedEmojis?: string[];
}

export default function EmojiPicker({
  onSelect,
  trigger = "⊕",
  triggerClassName = "",
  usedEmojis = [],
}: EmojiPickerProps) {
  const favorites = [...new Set([...DEFAULT_FAVORITES, ...usedEmojis])];
  const restEmojis = EMOJI_LIST.filter((e) => !favorites.includes(e));
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState<{ top: number; left: number } | null>(null);
  const popupRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const openPopup = () => {
    const btn = buttonRef.current;
    if (btn) {
      const rect = btn.getBoundingClientRect();
      const left = Math.max(
        8,
        Math.min(rect.right - POPUP_WIDTH, window.innerWidth - POPUP_WIDTH - 8)
      );
      setPosition({ top: rect.bottom + 4, left });
      setOpen(true);
    }
  };

  useEffect(() => {
    if (!open) return;
    const onClickOutside = (e: MouseEvent) => {
      const el = popupRef.current;
      const btn = buttonRef.current;
      if (el && btn && !el.contains(e.target as Node) && !btn.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", onClickOutside);
    return () => document.removeEventListener("click", onClickOutside);
  }, [open]);

  const handleSelect = (emoji: string) => {
    const shouldClose = onSelect(emoji);
    if (shouldClose === true) {
      setOpen(false);
    }
  };

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        onClick={() => (open ? setOpen(false) : openPopup())}
        className={`${triggerClassName}${open ? " !opacity-100" : ""}`}
        title="Add reaction"
        aria-label="Add reaction"
      >
        {trigger}
      </button>
      {open && position && (
        <div
          ref={popupRef}
          className="fixed z-50 w-[272px] max-h-[320px] overflow-y-auto p-2 bg-white dark:bg-gray-950 border-2 border-black dark:border-gray-100 flex flex-col gap-2"
          style={{ top: position.top, left: position.left }}
        >
          {favorites.length > 0 && (
            <div>
              <div className="text-[10px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1 px-0.5">
                Favorites
              </div>
              <div className="grid grid-cols-8 gap-0.5">
                {favorites.map((emoji) => (
                  <button
                    key={emoji}
                    type="button"
                    onClick={() => handleSelect(emoji)}
                    className="w-9 h-9 flex items-center justify-center text-xl border border-black dark:border-gray-600 bg-white dark:bg-gray-900 hover:bg-orange-100 dark:hover:bg-gray-800"
                    title={emoji}
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </div>
          )}
          <div>
            <div className="text-[10px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1 px-0.5">
              All
            </div>
            <div className="grid grid-cols-8 gap-0.5">
              {restEmojis.map((emoji) => (
                <button
                  key={emoji}
                  type="button"
                  onClick={() => handleSelect(emoji)}
                  className="w-9 h-9 flex items-center justify-center text-xl border border-black dark:border-gray-600 bg-white dark:bg-gray-900 hover:bg-orange-100 dark:hover:bg-gray-800"
                  title={emoji}
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
